import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { PageSection } from '../../../../Layout';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isLabMoistureContentTaken =
    (useSelector(createWorksheetSelector!('EmbeddedMoistureContent.IsLabMoistureContentTaken')) as
      | boolean
      | undefined) ?? false;

  return (
    <PageSection heading="Laboratory Moisture Content">
      <Field
        input={<RadioGroup />}
        label="Laboratory Moisture Content Taken"
        name="EmbeddedMoistureContent.IsLabMoistureContentTaken"
        confirmText="All data entered for the laboratory moisture content will be lost. Delete the laboratory moisture content?"
        confirm={isLabMoistureContentTaken}
        additionalMessagePaths={['EmbeddedMoistureContent.IsLabMoistureContentTaken']}
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />

      {isLabMoistureContentTaken && (
        <>
          <WorksheetAssociatedTestSection
            name="EmbeddedMoistureContent.MoistureContentTest"
            testType="Moisture Content"
            heading="BS 1377-2:1990 Clause 3.2 Moisture"
            associatedTestModel={{
              measured: true,
            }}
          />
          <Field input={<TextOutput />} name="EmbeddedMoistureContent.LabDryDensity" label="Dry Density" />
        </>
      )}
    </PageSection>
  );
};

const BsEmbeddedMoistureContent = withInjectedProps(Section);

export { BsEmbeddedMoistureContent };
export default BsEmbeddedMoistureContent;
